class MFRGrid {
    constructor( i, e, args ) {
        this.$index = i;
        this.$element = $( e );
        this.args = args;

        this.ease = "back";

        this.init();
    }

    init() {
        this.$item = this.$element.find( this.args.item );
        this.$itemWrapper = this.$element.find( this.args.itemWrapper );
        this.$filter = this.$element.find( this.args.filter );
        this.$selectedFilter = this.$element.find(`${this.args.filter}.is-active`);

        const filter = this.getURLFilter();
        
        const urlFilteredButtonElement = this.$element.find(
          `${this.args.filter}[data-filter="${filter}"]`
        );

        this.$filter.on( "click", this.__handleFilterClick.bind( this ) );

        if (filter) {
            this.updateItems(urlFilteredButtonElement );
        }
        else {
            this.updateItems(this.$selectedFilter);
        }

       this.initURLFiltering(urlFilteredButtonElement);
    }

    __handleFilterClick( e ) {
        if ($( e.currentTarget ).hasClass("is-active")) return;
        this.updateItems( $( e.currentTarget ) );
    }

    getURLFilter() {
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
        const filter = params.filter;

        return filter;
    }

    updateItems( element, urlTrigger ) {
        this.$filter.removeClass("is-active");
        element.addClass("is-active");

        const filter = element.data(this.args.filterAttribute);

        const itemState = Flip.getState( this.$item );
        const wrapperState = Flip.getState( this.$itemWrapper, { props: "height" } );
        if( filter == "*" ) {
            this.$item.css( "display", "block" );
        }
        else if( !filter ) { 
            return;
        }
        else {
            this.$item.css( "display", "none" );
            this.$element.find( `${ this.args.item }.${ this.args.filterPrefix }${ filter }` ).show();
        }

        // window.smoother.paused( true );

        Flip.from(itemState, {
            duration: .4,
            scale: true,
            absoluteOnLeave: true,
            ease: this.ease,
            stagger: 0.1,
            onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {opacity: 1, scale: 1, duration: 0.4}),
            onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: 0.4})
        });
        Flip.from( wrapperState, {
            duration: .4,
            scale: false
        } )
        setTimeout( () => {
            // window.smoother.paused( false );
            ScrollTrigger.refresh()
        }, 400 );

        if (!urlTrigger )
          this.$element.trigger("mfr:filtering", { data: filter });
    }

    initURLFiltering() {
        this.$element.on( "mfr:filtering", (e, filter) => {
            const urlParams = new URLSearchParams(window.location.search);

            urlParams.set("filter", filter.data);
            window.history.pushState(null, null, "?"+urlParams);
        });

        window.addEventListener("popstate", () => {
          const urlFilteredButtonElement = this.$element.find(
            `${this.args.filter}[data-filter="${this.getURLFilter()}"]`
          );

          this.updateItems( urlFilteredButtonElement, true );
        });
    }
}